<template>
  <!-- :default-active="$route.name" 解决面包屑切换页面时导航菜单不切换问题 -->
  <el-menu
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    :collapse="isCollapse"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    router
    :default-active="$route.name"
  >
    <h2>{{ isCollapse ? "后台" : "后台管理系统" }}</h2>

    <template v-for="item in menuData">
      <el-menu-item
        :key="item.name"
        :index="item.name"
        :route="item.path"
        @click="selectMenu(item)"
        v-if="!item.children"
      >
        <i :class="`el-icon-${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>
      <el-submenu :key="item.label" :index="item.label" v-else>
        <template slot="title">
          <i :class="`el-icon-${item.icon}`"></i>
          <span slot="title">{{ item.label }}</span>
        </template>
        <el-menu-item-group
          v-for="subItem in item.children"
          :key="subItem.name"
        >
          <el-menu-item
            :route="subItem.path"
            :index="subItem.name"
            @click="selectMenu(subItem)"
          >
            <i :class="`el-icon-${subItem.icon}`"></i>
            <span slot="title">{{ subItem.label }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import Cookie from "js-cookie";
import { mapState, mapMutations } from "vuex";
export default {
  name: "CommonAside",
  data() {
    return {
      menu: [
        {
          path: "/home",
          name: "home",
          label: "首页",
          icon: "s-home",
          hinde: false,
        },
        {
          path: "/adminList",
          name: "adminList",
          label: "小程序管理员",
          icon: "s-custom",
          hinde: false,
        },
        {
          path: "/resume",
          name: "resume",
          label: "简历库",
          icon: "s-claim",
          hinde: false,
        },
        {
          path: "/meeting",
          name: "meeting",
          label: "会议管理",
          icon: "video-play",
          hinde: false,
        },
        {
          path: "/regisList",
          name: "regisList",
          label: "报名列表",
          icon: "s-order",
          hinde: false,
        },
        {
          path: "/invitation",
          name: "invitation",
          label: "邀请函管理",
          icon: "document",
          hinde: false,
        },
        {
          path: "/refundList",
          name: "refundList",
          label: "退费管理",
          icon: "s-order",
          hinde: false,
        },
        // {
        //   path: "",
        //   name: "",
        //   label: "用户管理",
        //   icon: "user",
        //   hinde: false,
        //   children: [
        //     {
        //       path: "/user/userList",
        //       name: "userList",
        //       label: "用户列表",
        //       icon: "s-promotion",
        //       hinde: false,
        //     },
        //     {
        //       path: "/user/userCard",
        //       name: "userCard",
        //       label: "用户名片",
        //       icon: "s-promotion",
        //       hinde: false,
        //     },
        //   ],
        // },
        // {
        //   path: "",
        //   name: "",
        //   label: "医生管理",
        //   icon: "s-custom",
        //   hinde: false,
        //   children: [
        //     {
        //       path: "/medic/list",
        //       name: "MedicList",
        //       label: "医生列表",
        //       icon: "s-promotion",
        //       hinde: false,
        //     },
        //     {
        //       path: "/medic/card",
        //       name: "MedicCard",
        //       label: "医生名片",
        //       icon: "s-promotion",
        //       hinde: false,
        //     },
        //   ],
        // },
       
      ],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    ...mapMutations("tab", ["selectMenu"]),
  },
  computed: {
    ...mapState("tab", ["isCollapse"]),
    menuData() {
      // console.log(JSON.parse(Cookie.get('menu')))
      return this.menu.filter((item) => !item.hinde);
    },
    //没有子菜单
    noChildren() {
      return this.menuData.filter((item) => !item.children);
    },
    //有子菜单
    hasChildren() {
      return this.menuData.filter((item) => item.children);
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu {
  height: 100vh;
  min-height: 100vh;
  border-right: 0px;
  h2 {
    color: #fff;
    text-align: center;
    line-height: 46px;
    font-size: 18px;
    font-weight: 400;
  }
}
</style>
